import React from "react";
import Modal from "../../../containers/Modal";
import {Input} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
// import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";

export default function ShowUserModal({isOpen, close, theme, data}) {
   if (!data) return null;
   return (
      <Modal
         isOpen={isOpen}
         close={() => {
            close();
         }}
         // confirm={true}
         theme={theme}
         title="Información de usuario"
      >
         <DivModal>
            <div>
               <Grid>
                  <Col large="9">
                     <p className="textModal">Nombre:</p>
                     <Input className="readGhost principal" defaultValue={data.name} readOnly={true} placeholder="Nombre" name="name" />
                  </Col>
                  {/* <Col large="4" /> */}
                  <Col large="5">
                     <p className="textModal">Área:</p>
                     <Input className="readGhost" defaultValue={data.area} readOnly={true} placeholder="Area" name="area" />
                  </Col>
                  <Col large="2" />
                  <Col large="5">
                     <p className="textModal">Email:</p>
                     <Input className="readGhost" defaultValue={data.email} readOnly={true} placeholder="E-Mail" name="email" />
                  </Col>
                  <Col large="5">
                     <p className="textModal">Contraseña:</p>
                     <Input className="readGhost" defaultValue={data.password} readOnly={true} placeholder="Contraseña" name="password" />
                  </Col>
                  <Col large="2" />
                  <Col large="5"></Col>
                  <Col large="5"></Col>
               </Grid>
            </div>
         </DivModal>
      </Modal>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
`;
